import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/components/CaseStudyPage/components/Header/index.js